"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KodenPanelList = void 0;
const React = __importStar(require("react"));
const react_query_1 = require("react-query");
const material_1 = require("@mui/material");
const DragHandle_1 = __importDefault(require("@mui/icons-material/DragHandle"));
const react_beautiful_dnd_1 = require("react-beautiful-dnd");
const koden_koden_crud_1 = require("@scott/koden.koden-crud");
const Panel_1 = __importDefault(require("./components/Panel"));
const PanelListRow_1 = __importDefault(require("./components/PanelListRow"));
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
const KodenPanelList = ({ title, resource, headerBackgroundColor, columns, columnPlaceHolder, }) => {
    const queryKey = (0, koden_koden_crud_1.getFindAllKey)(resource);
    const queryClient = (0, react_query_1.useQueryClient)();
    const patchMutation = (0, koden_koden_crud_1.usePatchMutation)((0, koden_koden_crud_1.appendPath)(resource, "/priority"));
    const { isLoading, data } = (0, koden_koden_crud_1.useFindAll)(resource);
    if (isLoading) {
        return React.createElement(material_1.CircularProgress, { color: "info" });
    }
    return (React.createElement(Panel_1.default, { headerBackgroundColor: headerBackgroundColor, title: React.createElement(React.Fragment, null, title) },
        React.createElement(react_beautiful_dnd_1.DragDropContext, { onDragEnd: ({ source, destination }) => {
                if (destination) {
                    const sourceRecord = data[source.index];
                    const destinationRecord = data[destination.index];
                    if (sourceRecord.id !== destinationRecord.id) {
                        const reorderedData = reorder(data, source.index, destination.index);
                        queryClient.setQueryData(queryKey, () => {
                            return reorderedData;
                        });
                        patchMutation.mutate({
                            options: reorderedData.map(({ id }, priority) => {
                                return { id, priority };
                            }),
                        });
                    }
                }
            } },
            React.createElement(react_beautiful_dnd_1.Droppable, { droppableId: "droppable" }, (droppableProvided) => (React.createElement("div", { ref: droppableProvided.innerRef },
                data.map((option, index) => {
                    const key = `item-${option.id}`;
                    return (React.createElement(react_beautiful_dnd_1.Draggable, { key: key, draggableId: key, index: index }, (draggableProvided) => (React.createElement("div", Object.assign({ ref: draggableProvided.innerRef }, draggableProvided.draggableProps, draggableProvided.dragHandleProps),
                        React.createElement("div", { style: { display: "flex" } },
                            React.createElement(PanelListRow_1.default, { key: option.id, resource: resource, columns: columns, option: option, columnPlaceHolder: columnPlaceHolder }),
                            React.createElement("div", { style: { display: "flex", alignItems: "center" } },
                                React.createElement(DragHandle_1.default, null)))))));
                }),
                droppableProvided.placeholder))))));
};
exports.KodenPanelList = KodenPanelList;
exports.default = exports.KodenPanelList;
//# sourceMappingURL=koden-panel-list.js.map